import styles from '@/styles/ui.module.css';

export default function LoadingSpinner() {
  return (
    <div className={styles.spinnerWrapper}>
      <div className={styles.spinnerShell}>
        <span className={styles.spinnerTrack} />
        <span className={styles.spinnerRing} />
      </div>
    </div>
  );
}
